module.exports = "<div class=\"widgets\">\n\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <ba-card cardTitle=\"Sector Category List\" baCardClass=\"with-scroll\">\n        <sector-category-list></sector-category-list>\n      </ba-card>\n    </div>\n\n    <div class=\"col-md-4\">\n      <ba-card cardTitle=\"New Sector Category\" baCardClass=\"with-scroll\">\n        <sector-category-form></sector-category-form>\n      </ba-card>\n    </div>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/localization/components/sector-categories/sector-categories.component.html
// module id = 868
// module chunks = 8